import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { ChatEventFragment } from '@spotify/confidence-graphql';

export interface ChatEventExtensionOptions
  extends ItemRenderExtensionOptions<ChatEventFragment> {}

export const ChatEventExtensions =
  createItemRenderExtensions<ChatEventExtensionOptions>({
    id: 'chat-event',
  });

export const createChatEventExtension = (
  options: ChatEventExtensionOptions,
) => {
  return createItemRenderExtension<ChatEventExtensionOptions>(options);
};

export const useChatEventExtensions = () => {
  return useItemRenderExtensions<ChatEventExtensionOptions>(
    ChatEventExtensions,
  );
};
